import styled from 'styled-components';

import { GALLERY_ITEM_HEIGHT } from '@telialt/common-gallery/src/constants';
import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const MarketingTagImg = styled.img`
    position: absolute;
    top: 0;
    transform: translateY(calc((${GALLERY_ITEM_HEIGHT.MOBILE} - 100%) / 2));
    right: 0;
    max-width: 6.25rem;
    max-height: 6.25rem;
    width: auto;
    height: auto;
    pointer-events: none;

    ${purpurMedia('lg')`
        top: 0;
        transform: translateY(calc((${GALLERY_ITEM_HEIGHT.DESKTOP} - 100%) / 2 ));
    `};
`;
